package com.essntl.features.invoice.ui.addeditinvoice.components.sidebar

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import com.essntl.core.quickbooks.data.QuickbooksInvoiceRequest.Line.Companion.SALES_TOTAL_LINE_DETAIL
import com.essntl.core.utils.utils.formatIntMoney
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceState
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.EsConstants.LargeSectionHorizontalPadding
import com.essntl.uikit.components.utils.EsConstants.LargeSectionVerticalPadding
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlin.math.roundToInt

@Composable
fun AddEditInvoiceTotalSection(
    state: AddEditInvoiceState,
) {
    val linesPriceDetailsList = remember(state.getQuickbooksInvoice.data) {
        state.getQuickbooksInvoice.data?.Line
            .orEmpty()
            .mapNotNull {
                if (it.DetailType == SALES_TOTAL_LINE_DETAIL || it.Amount == null)
                    return@mapNotNull null

                PriceDetailsUiState(
                    title = it.SalesItemLineDetail?.ItemRef?.name ?: "Line",
                    price = ((it.Amount ?: 0.0) * 100).roundToInt(),
                    quantity = it.SalesItemLineDetail?.Qty ?: 1,
                    unitPrice = (it.SalesItemLineDetail?.UnitPrice?.times(100))?.roundToInt(),
                )
            }
    }

    val subTotalLine = remember(state.getQuickbooksInvoice.data) {
        val line = state.getQuickbooksInvoice.data?.Line
            .orEmpty()
            .firstOrNull { it.DetailType == SALES_TOTAL_LINE_DETAIL }
            ?: return@remember null

        PriceDetailsUiState(
            title = "Subtotal",
            price = ((line.Amount ?: 0.0)).roundToInt(),
        )
    }

    val totalAmount = remember(state.getQuickbooksInvoice.data) {
        ((state.getQuickbooksInvoice.data?.TotalAmt ?: 0.0) * 100).roundToInt()
    }

    val balance = remember(state.getQuickbooksInvoice.data) {
        ((state.getQuickbooksInvoice.data?.Balance ?: 0.0) * 100).roundToInt()
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(color = MaterialTheme.esColorScheme.bgSecondaryHover)
            .padding(
                vertical = LargeSectionVerticalPadding,
                horizontal = LargeSectionHorizontalPadding,
            ),
    ) {
        Text(
            text = "Total",
            style = MaterialTheme.esTypography.h3Bold24,
            color = MaterialTheme.esColorScheme.textPrimary,
        )

        Spacer(modifier = Modifier.height(2.spacing))

        InvoicingPriceDetails(
            title = "Services",
            priceDetailsList = linesPriceDetailsList,
            modifier = Modifier.fillMaxWidth(),
        )

        Spacer(modifier = Modifier.height(4.spacing))

        if (subTotalLine != null) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier
                    .fillMaxWidth(),
            ) {
                Text(
                    text = "Subtotal",
                    style = MaterialTheme.esTypography.p2Regular14,
                    color = MaterialTheme.esColorScheme.textPrimary,
                )

                Spacer(modifier = Modifier.weight(1f))

                Text(
                    text = "$${formatIntMoney((subTotalLine.price * 100))}",
                    style = MaterialTheme.esTypography.h3Bold24,
                    color = MaterialTheme.esColorScheme.textPrimary,
                )
            }

            Spacer(modifier = Modifier.height(4.spacing))
        }

        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .fillMaxWidth(),
        ) {
            Text(
                text = "Total amount",
                style = MaterialTheme.esTypography.p2Regular14,
                color = MaterialTheme.esColorScheme.textPrimary,
            )

            Spacer(modifier = Modifier.weight(1f))

            Text(
                text = "$${formatIntMoney(totalAmount)}",
                style = MaterialTheme.esTypography.h3Bold24,
                color = MaterialTheme.esColorScheme.textPrimary,
            )
        }

        Spacer(modifier = Modifier.height(4.spacing))

        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .fillMaxWidth(),
        ) {
            Text(
                text = "Balance",
                style = MaterialTheme.esTypography.h3Bold24,
                color = MaterialTheme.esColorScheme.textError,
            )

            Spacer(modifier = Modifier.weight(1f))

            Text(
                text = "$${formatIntMoney(balance)}",
                style = MaterialTheme.esTypography.h3Bold24,
                color = MaterialTheme.esColorScheme.textError,
            )
        }
    }
}